export const appPolicies = {
    utentiVisualizzazione: "Utenti.Visualizzazione",
    utentiInserimentoModifica: "Utenti.InserimentoModifica",
    utentiEliminazioneRipristino: "Utenti.EliminazioneRipristino",
    utentiResetPassword: "Utenti.ResetPassword",
    utentiCancellazione: "Utenti.Cancellazione",
    utentiSincronizzazione: "Utenti.Sincronizzazione",
    utentiGestioneRichiestaCredenziali: "Utenti.GestioneRichiestaCredenziali",

    edificiVisualizzazione: "Edifici.Visualizzazione",
    edificiInserimentoModifica: "Edifici.InserimentoModifica",
    edificiEliminazioneRipristino: "Edifici.EliminazioneRipristino",
    edificiAbilitaDisabilita: "Edifici.AbilitaDisabilita",

    zoneVisualizzazione: "Zone.Visualizzazione",
    zoneInserimentoModifica: "Zone.InserimentoModifica",
    zoneEliminazioneRipristino: "Zone.EliminazioneRipristino",
    zoneAbilitaDisabilita: "Zone.AbilitaDisabilita",

    stanzeVisualizzazione: "Stanze.Visualizzazione",
    stanzeInserimentoModifica: "Stanze.InserimentoModifica",
    stanzeEliminazioneRipristino: "Stanze.EliminazioneRipristino",
    stanzeAbilitaDisabilita: "Stanze.AbilitaDisabilita",

    postazioniVisualizzazione: "Postazioni.Visualizzazione",
    postazioniInserimentoModifica: "Postazioni.InserimentoModifica",
    postazioniEliminazioneRipristino: "Postazioni.EliminazioneRipristino",
    postazioniAbilitaDisabilita: "Postazioni.AbilitaDisabilita",
    postazioniCreaQrCode: "Postazioni.CreaQrCode",

    prenotazionePrenotaPerAltri: "Prenotazione.PrenotazionePerAltri",
    prenotazioneCancellaTutti: "Prenotazione.CancellaPrenotazioneTutti",
    prenotazioneCheckoutTutti: "Prenotazione.CheckoutTutteLePrenotazioni",

    generalVisualizzazioneCompleta: "General.VisualizzazioneCompleta",
};